import { computed } from 'vue';
import { useTheme } from 'vuetify';
import { useLocalStorage } from '@vueuse/core';
import '@ilteducation/themes/games/style/fonts.scss';
import { gamesLight, gamesDark } from '@ilteducation/themes/games/themes';

export const useGamesTheme = () => {
  const vuetifyTheme = useTheme();
  // The host app's Vuetify instance may not know the games themes, so register them here.
  type InternalTheme = (typeof vuetifyTheme.themes.value)[string];
  vuetifyTheme.themes.value.gamesLight ??= gamesLight as InternalTheme;
  vuetifyTheme.themes.value.gamesDark ??= gamesDark as InternalTheme;

  const mode = useLocalStorage<'dark' | 'light'>('games-theme-mode', 'dark');
  const theme = computed(() => (mode.value === 'dark' ? 'gamesDark' : 'gamesLight'));
  const toggleMode = () => {
    mode.value = mode.value === 'dark' ? 'light' : 'dark';
  };

  return { mode, theme, toggleMode };
};
